export const routesPath = {
    USERS: "/users",
    CLIENT_USER: "/users/client-user",
    BRAND_USER: "/users/brand-user",
}